import React from 'react'
import './Portfolio.css';
import IMG1 from '../../assets/portfolio1.jpg'
import IMG2 from '../../assets/portfolio2.jpg'
import IMG3 from '../../assets/portfolio3.jpg'
import IMG4 from '../../assets/portfolio4.jpg'
import IMG5 from '../../assets/portfolio5.png'
import IMG6 from '../../assets/portfolio6.jpg'

const data=[
  {
    id:1,
    image:IMG1,
    title:'Modern E-commerce website',
    github:'https://github.com/raidenkhan/simpleEcommerceSite',
    demo:'https://simpleecommercesite.netlify.app/#'
  },
  {
    id:2,
    image:IMG2,
    title:'Built a full Admin Dashboard',
    github:'https://github.com/raidenkhan/projects/commit/e7a42089171b7b391247e9f2b1862e32cf88a4e9',
    demo:' '
  },
  {
    id:3,
    image:IMG3,
    title:'Created A complete login form /Page',
    github:'hhttps://github.com/raidenkhan/projects/tree/main/registration',
    demo:'https://dribble.com/shorts/1673715-Crypto-currency-dashboards-and-financial-data-visualization '
  },
  {
    id:4,
    image:IMG4,
    title:'Added my first portfoli',
    github:'https://github.com/raidenkhan/projects/tree/main/MY%20PORTFOLIO',
    demo:'https://dribble.com/shorts/1673715-Crypto-currency-dashboards-and-financial-data-visualization '
  },
 
  {
    id:5,
    image:IMG5,
    title:'Crypto Currency DashBoard & Financial Visualization',
    github:'https://github.com',
    demo:'https://dribble.com/shorts/1673715-Crypto-currency-dashboards-and-financial-data-visualization '
  },
  {
    id:6,
    image:IMG6,
    title:'Started A github Collaboration',
    github:'https://github.com',
    demo:'https://dribble.com/shorts/1673715-Crypto-currency-dashboards-and-financial-data-visualization '
  },
]
const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>PortFolio</h2>
      <div className="container portfolio__container">
        {
          data.map(({id,image,title,github,demo})=>{
              return(
                <article className="portfolio__item" key={id}>
        <div className="portfolio__item-image">
          <img src={image} alt={title}/>
        </div>
        <h3>{title}</h3>
        <div className="portfolio-item-cta">
        <a href={github} className='btn'> GitHub </a>
        <a href={demo} className='btn btn-primary' target='_blank' rel="noreferrer"> Live Demo </a>
        </div>
        </article>
              )
          })
        }
      </div>
    </section>
  )
}

export default Portfolio